import { Outlet } from 'react-router-dom';
import { Banner } from '@/components/Banner';
import { Box, Flex } from '@/ui';
import { SuspenseContainer } from '../SuspenseContainer';
import { Background } from './components/Background';
import { Header } from './components/Header';
import { usePreloadAssets } from './hooks/usePreloadAssets';

export const MagicTabsLayout = () => {
  usePreloadAssets();

  return (
    <>
      <Background />

      <Flex color="customgray.textdark" direction="column" flex="1">
        {/* The magic mascot measures this to stop below the nav when it
            shrinks out of the prompt's way. */}
        <Box id="site-nav">
          <Banner />
          <Header />
        </Box>
        <SuspenseContainer>
          <Outlet />
        </SuspenseContainer>
      </Flex>
    </>
  );
};
